const safeLogs = {
    addGlobalContext: () => {},
    debug: (...args) => console.log(...args),
    warn: (...args) => console.warn(...args),
    info: (...args) => console.info(...args),
    error: (...args) => console.error(...args),
}

window._guLogger = window._guLogger || safeLogs

const Logger = window._guLogger
export default Logger
